import { Box, BoxProps } from '@chakra-ui/react';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { FileUploadButton } from '@/components/FileUploadButton';

export const AttachmentButton: React.FC<
  {
    attachmentLimit?: number;
  } & BoxProps
> = ({ attachmentLimit, ...boxProps }) => {
  const { trigger } = useFormContext();

  return (
    <Box {...boxProps}>
      <Controller
        name="attachments"
        rules={{
          validate: (value) => {
            return (
              attachmentLimit === undefined ||
              !value ||
              value.length <= attachmentLimit ||
              `Cannot attach more than ${attachmentLimit} file${
                attachmentLimit !== 1 ? 's' : ''
              } `
            );
          },
        }}
        render={({ field: { onChange, value, ref, onBlur } }) => (
          <FileUploadButton
            colorScheme="gray"
            size="sm"
            borderRadius="full"
            value={value}
            onChange={(value) => {
              onChange(value);
              trigger('attachments');
            }}
            onBlur={onBlur}
            ref={ref}
          />
        )}
      />
    </Box>
  );
};
